var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M8.667 1.334v11.333a.667.667 0 101.333 0V1.334a.667.667 0 00-1.333 0zM1.333 12.667V1.334a.667.667 0 10-1.333 0v11.333a.667.667 0 101.333 0zm4.334 0V1.334a.667.667 0 00-1.334 0v11.333a.667.667 0 101.334 0z"}})}
var staticRenderFns = []

export { render, staticRenderFns }